import React from 'react'
import { FunderUser, NonprofitOrgUser } from 'TypeDefs/Team'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@resiliatech/birdsong'
import { styled } from '@mui/material'
import {
  NameCell,
  RelationshipCell,
  RoleCell,
  StatusCell,
  ActionButtonCell,
  ActionButtonFunderCell,
} from './cells/index'
import { orderUsers } from './utils'

type Props = {
  users: NonprofitOrgUser[] | FunderUser[]
  updateUserSettings: () => void
  setShowBirdsongSnackbar: (value: React.SetStateAction<boolean>) => void
  setBirdsongSnackbarMessage: (value: React.SetStateAction<string>) => void
  setDeletedUser: (
    value: React.SetStateAction<{
      id: number
      email: string
      name?: string
    } | null>
  ) => void
  isFunder?: boolean
}

export const NewTeamPageTable = ({
  users,
  updateUserSettings,
  setShowBirdsongSnackbar,
  setBirdsongSnackbarMessage,
  setDeletedUser,
  isFunder = false,
}: Props) => (
  <StyledTableContainer>
    <Table table-caption="Table of your organization's Resilia users">
      <TableHead>
        <TableRow>
          <TableHeaderCell>Name</TableHeaderCell>
          {isFunder && <TableHeaderCell>Relationship</TableHeaderCell>}
          <TableHeaderCell>Role</TableHeaderCell>
          <TableHeaderCell>Status</TableHeaderCell>
          <TableCell />
        </TableRow>
      </TableHead>
      <TableBody>
        {orderUsers(users).map((user) => {
          const relationship = isFunder
            ? (user as FunderUser).funderOrgRole
            : (user as NonprofitOrgUser).nonprofitOrgRole

          return (
            <TableRow key={user.user.id}>
              <NameCell
                firstName={user.user.firstName}
                lastName={user.user.lastName}
                emailAddress={user.user.email}
              />
              {isFunder && (
                <RelationshipCell
                  userRelationship={relationship}
                  updateUserSettings={updateUserSettings}
                  user={user.user}
                  setShowBirdsongSnackbar={setShowBirdsongSnackbar}
                  setBirdsongSnackbarMessage={setBirdsongSnackbarMessage}
                  isFunder={isFunder}
                />
              )}
              <RoleCell
                resiliaRole={user.role || 'MEMBER'}
                updateUserSettings={updateUserSettings}
                user={user.user}
                setShowBirdsongSnackbar={setShowBirdsongSnackbar}
                setBirdsongSnackbarMessage={setBirdsongSnackbarMessage}
                isFunder={isFunder}
              />
              <StatusCell
                isActive={!!user.user.firstName && !!user.user.lastName}
                lastInviteSentAt={user.lastInviteSentAt}
                createdAt={user.user.createdAt}
              />
              {isFunder && (
                <ActionButtonFunderCell
                  setShowBirdsongSnackbar={setShowBirdsongSnackbar}
                  setBirdsongSnackbarMessage={setBirdsongSnackbarMessage}
                  user={user as FunderUser}
                  setDeletedUser={setDeletedUser}
                />
              )}
              {!isFunder && (
                <ActionButtonCell
                  setShowBirdsongSnackbar={setShowBirdsongSnackbar}
                  setBirdsongSnackbarMessage={setBirdsongSnackbarMessage}
                  nonprofitOrgUser={user as NonprofitOrgUser}
                  setDeletedUser={setDeletedUser}
                />
              )}
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
  </StyledTableContainer>
)

const TableHeaderCell = styled(TableCell)`
  font-weight: 600;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
`

const StyledTableContainer = styled(TableContainer)`
  background-color: #ffffff;
`
